export enum CommunicationStyle {
  FRIENDLY = 'Friendly',
  DIRECT = 'Direct',
  PROFESSIONAL = 'Professional',
}

//Get an array of values
export const CommunicationStyleValues = [
  CommunicationStyle.FRIENDLY,
  CommunicationStyle.DIRECT,
  CommunicationStyle.PROFESSIONAL,
];
